import i18n from "i18n";
import { capitalize } from "helpers/utils/utils_general";

const items = [
  {
    icon: "product",
    title: capitalize(i18n.t("products")),
    to: "/admin/products",
    mobile: true,
    permission: "read_items",
    activePaths: [
      "/admin/embalajes",
      "/admin/embalajes/detail",
      "/admin/products/load",
      "/admin/products/load-massive-product",
      "/admin/categories",
      "/admin/embalajes/add",
      "/admin/products/details"
    ]
  },
  {
    icon: "documento",
    title: capitalize(i18n.t("orders")),
    to: "/admin/orders",
    mobile: true,
    permission: "read_orders"
  },
  {
    icon: "stock",
    title: capitalize(i18n.t("stock")),
    to: "/admin/stock",
    mobile: true,
    permission: "read_stock",
    activePaths: [
      "/admin/ficha-de-stock",
      "/admin/auditoria-de-stock",
      "/admin/localization-product",
      "/admin/localization-tag",
      "/admin/stock/create-audit",
      "/admin/stock/view-audits",
      "/admin/stock/view-audit-details"
    ]
  },
  {
    icon: "tags",
    title: capitalize(i18n.t("tags")),
    to: "/admin/more-options-tags",
    mobile: true,
    permission: "read_config_tag",
    activePaths: [
      "/admin/tags/print",
      "/admin/tags/reprint",
      "/admin/tag-traceability",
      "/admin/tags/associate",
      "/admin/config_tags",
      "/admin/code_tags/edit"
    ]
  },
  {
    icon: "dispositivos2",
    title: capitalize(i18n.t("devices")),
    to: "/admin/devices",
    mobile: true,
    permission: "read_devices"
  },
  {
    icon: "presis",
    title: capitalize(i18n.t("alerts")),
    to: "/admin/presisactivity",
    mobile: true,
    permission: "read_alerts"
  },
  {
    icon: "arc",
    title: capitalize(i18n.t("arch")),
    to: "/admin/arc-activity",
    mobile: true,
    permission: "all"
  },
  {
    icon: "reportes",
    title: capitalize(i18n.t("reports")),
    to: "/admin/reportes",
    mobile: true,
    permission: "reports"
  },
  {
    icon: "configuraciones",
    title: capitalize(i18n.t("more.options")),
    to: "/admin/more-options",
    mobile: true,
    permission: "all",
    activePaths: [
      "/admin/businessnodes",
      "/admin/clients",
      "/admin/providers",
      "/admin/applications",
      "/admin/businesses",
      "/admin/users",
      "/admin/roles",
      "/admin/active-node",
      "/admin/more-options/1"
    ]
  },
  {
    icon: "account",
    title: capitalize(i18n.t("my.account")),
    to: "/admin/account",
    permission: "all"
  }
];

export default items;
